import React from "react";

const ExperienceComponent = () => {
  return (
    <div>
      <div className="container">
        <div className="row" style={{ color: "#292925" }}>
          <div className="col-12">.</div>
        </div>

        <div className="row">
          <div
            className="col-md-4"
            style={{
              color: "#c0c0c0",
              // backgroundColor: "transparent",
              // display: "flex",
              // justifyContent: "initial",
            }}
          >
            WORK EXPERIENCE
          </div>
          <div
            className="col-md-4"
            // style={{ display: "flex", justifyContent: "center" }}
          >
            <a
              target="_blank"
              href="https://www.linkedin.com/company/riversilica-technologies-pvt-ltd--/mycompany/"
              style={{ color: "#c0c0c0" }}
            >
              RIVERSILICA TECHNOLOGIES
            </a>
          </div>
          <div
            className="col-md-4"
            style={{
              fontStretch: "extra-expanded",
              color: "#c0c0c0",
              // backgroundColor: "transparent",
              // display: "flex",
              // justifyContent: "center",
            }}
          >
            Software Engineer (Frontend)
            <footer
              style={{
                fontSize: "10px",
                fontStyle: "italic",
                // backgroundColor: "transparent",
                // display: "flex",
                // justifyContent: "flex-end",
              }}
            >
              (Nov 2022 - present)
            </footer>
          </div>
          <div className="row" style={{ color: "#292925" }}>
            <div className="col-12">.</div>
          </div>
          <div className="row" style={{ color: "#292925" }}>
            <div className="col-12">.</div>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-4"
            style={{
              color: "#c0c0c0",
              // backgroundColor: "transparent",
              // display: "flex",
              // justifyContent: "center",
            }}
          >
            VOLUNTEER EXPERIENCE
          </div>
          <div
            className="col-md-4"
            style={{
              color: "#c0c0c0",
              // backgroundColor: "transparent",
              // display: "flex",
              // justifyContent: "center",
            }}
          >
            <a
              target="_blank"
              href="https://www.linkedin.com/company/girlupgleam/"
              style={{ color: "#c0c0c0" }}
            >
              GIRLUP GLEAM
            </a>
            <footer
              style={{
                fontSize: "10px",
                fontStyle: "italic",
                // backgroundColor: "transparent",
                // display: "flex",
                // justifyContent: "flex-end",
              }}
            >
              (Init. United Nations Foundation)
            </footer>
          </div>
          <div
            className="col-md-4"
            style={{
              fontStretch: "extra-expanded",
              color: "#c0c0c0",
              // backgroundColor: "transparent",
              // display: "flex",
              // justifyContent: "center",
            }}
          >
            Content Writer
            <footer
              style={{
                fontSize: "10px",
                fontStyle: "italic",
                // backgroundColor: "transparent",
                // display: "flex",
                // justifyContent: "flex-end",
              }}
            >
              (July 2020 - Aug 2022)
            </footer>
          </div>
        </div>

        <div className="row" style={{ color: "#292925" }}>
          <div className="col-12">.</div>
        </div>
        <div className="row" style={{ color: "#292925" }}>
          <div className="col-12">.</div>
        </div>

        <div className="row">
          <div
            className="col-md-4"
            style={{
              color: "#c0c0c0",
              // backgroundColor: "transparent",
              // display: "flex",
              // justifyContent: "center",
            }}
          >
            EDUCATION
          </div>
          <div
            className="col-md-4"
            style={{
              color: "#c0c0c0",
              // backgroundColor: "transparent",
              // display: "flex",
              // justifyContent: "center",
            }}
          >
            <a
              target="_blank"
              href="https://www.linkedin.com/school/city-engineering-college/"
              style={{ color: "#c0c0c0" }}
            >
              CITY ENGINEERING COLLEGE
            </a>
          </div>
          <div
            className="col-md-4"
            style={{
              fontStretch: "extra-expanded",
              color: "#c0c0c0",
              // backgroundColor: "transparent",
              // display: "flex",
              // justifyContent: "center",
            }}
          >
            B.E (CSE)
            <footer
              style={{
                fontSize: "10px",
                fontStyle: "italic",
                // backgroundColor: "transparent",
                // display: "flex",
                // justifyContent: "flex-end",
              }}
            >
              (July 2018 - Aug 2022)
            </footer>
          </div>
        </div>
        <div className="row" style={{ color: "#292925" }}>
          <div className="col-12">.</div>
        </div>
      </div>
    </div>
  );
};

export default ExperienceComponent;
